var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-5 bg",attrs:{"elevation":"1"}},[_c('h1',{staticClass:"green--text ma-2"},[_vm._t("header")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }